import api from './api';
import { CourseCategory } from '../types';

export const categoryService = {
  list: async (query?: string) => {
    const params: any = {};
    if (query) params.q = query;
    const response = await api.get<{ categories: CourseCategory[] }>('/categories', { params });
    return response.data.categories;
  },

  create: async (payload: { name: string; description?: string }) => {
    const response = await api.post<{ message: string; category: CourseCategory }>('/categories', payload);
    return response.data.category;
  },

  update: async (id: number, payload: { name?: string; description?: string }) => {
    const response = await api.put<{ message: string; category: CourseCategory }>(`/categories/${id}`, payload);
    return response.data.category;
  },

  remove: async (id: number) => {
    const response = await api.delete<{ message: string }>(`/categories/${id}`);
    return response.data;
  },
};



